import React, { useState, useEffect, useRef } from "react";
import { FiLink } from "react-icons/fi";

const SearchSelectPopup = ({
  items = [],
  labelKey = "name",
  onSelect,
  onAddNew,
  allowMultiple = true,
  placeholder = "Search...",
  initialSelected = [],
  useCheckbox = true,
  onClose,
  currentCompany, 
}) => {
  const [selectedItems, setSelectedItems] = useState(initialSelected);
  const [inputValue, setInputValue] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const popupRef = useRef(null);

  useEffect(() => {
    const lowerSearch = inputValue.toLowerCase();
    const filtered = items
      .filter((item) => {
        const label = (item[labelKey] || "").toLowerCase();
        return label.includes(lowerSearch) && label.trim() !== "";
      })
      .sort((a, b) => (a[labelKey] || "").localeCompare(b[labelKey] || ""));
    setFilteredItems(filtered);
  }, [items, inputValue, labelKey]);

  useEffect(() => {
    setSelectedItems(initialSelected);
  }, [initialSelected]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        onClose?.();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const isSelected = (item) =>
    selectedItems.some((sel) => sel.id === item.id);

  const toggleItem = (item) => {
    let newSelection;
    if (isSelected(item)) {
      newSelection = selectedItems.filter((sel) => sel.id !== item.id);
    } else {
      newSelection = [...selectedItems, item];
    }
    setSelectedItems(newSelection);
    onSelect?.(newSelection);
  };

  return (
    <div
      ref={popupRef}
      className="search-select-popup"
      style={{
        position: "absolute",
        top: "0", 
        right: "100%", 
        marginRight: "8px",
        background: "#fff",
        border: "1px solid #ddd",
        borderRadius: "8px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        padding: "8px",
        zIndex: 9999,
        whiteSpace: "nowrap", 
      }}
    >
      <input
        type="text"
        value={inputValue}
        placeholder={placeholder}
        onChange={(e) => setInputValue(e.target.value)}
        style={{
          width: "100%",
          marginBottom: "8px",
          padding: "6px",
          boxSizing: "border-box",
          border: "1px solid #ccc",
          borderRadius: "4px",
        }}
      />
      <div style={{ maxHeight: "200px", overflowY: "auto" }}>
        {filteredItems.length > 0 ? (
          filteredItems.map((item) => (
            <div
              key={item.id}
              className="search-select-item"
              onClick={() => toggleItem(item)}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                padding: "4px 8px",
              }}
            >
              {useCheckbox && (
                <input
                  type="checkbox"
                  checked={isSelected(item)}
                  readOnly
                  style={{ marginRight: "6px" }}
                />
              )}
              <span style={{ fontSize: "14px", flexGrow: 1 }}>
                {item[labelKey]}
              </span>
              {item.company &&
                currentCompany &&
                item.company.trim() !== currentCompany.trim() && (
                  <FiLink
                    size={16}
                    style={{ marginLeft: "6px" }}
                    title={`Already linked to ${item.company}`}
                  />
                )}
            </div>
          ))
        ) : (
          <div
            style={{
              color: "#666",
              fontSize: "14px",
              padding: "4px 8px",
            }}
          >
            No results found
          </div>
        )}
      </div>
      {onAddNew && (
        <div
          onClick={onAddNew}
          style={{
            borderTop: "1px solid #eee",
            marginTop: "8px",
            paddingTop: "8px",
            cursor: "pointer",
            fontSize: "14px",
            color: "#007AFF",
            fontWeight: 500,
          }}
        >
          + Add New
        </div>
      )}
    </div>
  );
};

export default SearchSelectPopup;
